import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing, shadow } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "RichTextInputstyle__Container",
  componentId: "sc-14ha6y2-0"
})(["margin-top:", ";padding:", ";border:1px solid ", ";border-radius:", ";box-shadow:", ";"], getSpacing(2), getSpacing(3), colorUsage.inputBorder, borderRadius.large, shadow.bottom.light);
export { Container };